import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Button } from '@sumologic/yama-ds-components';

import Automation from '~/models/Automation';

import { toErrorMessage } from '~/modules/helpers/error';

import ResultUserChoiceCard from '~/components/RunbookResultsCards/ResultUserChoiceCard/ResultUserChoiceCard';

import Collapse from '~/containers/Collapse/Collapse';
import Translate from '~/components/Translate/Translate';

/**
 * Initial UserChoice page
 * @return {*}
 * @constructor
 * @author FM/AC
 */
export default function UserChoice({}) {
    const params = useParams();
    const location = useLocation();
    const [result, setResult] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [error, setError] = useState(null);

    /**
     * Check if auth is required and reply to user choice
     * @author FM
     */
    const replyUserChoice = () => {
        let userChoiceId = null;
        let authRequired = true;
        //FM: get user choice id from url
        const paramId = params?.id;
        if (paramId) {
            userChoiceId = paramId;
        } else {
            const searchParams = new URLSearchParams(location.search);
            userChoiceId = searchParams.get('answer');
            authRequired = false;
        }
        //FM: ger user choice data
        const promise = authRequired
            ? Automation.answerUserchoiceFromLink(userChoiceId)
            : Automation.answerUserchoiceNoAuth(userChoiceId);
        //FM: resolve promise
        promise
            .then(response => {
                setResult(response.data);
                setIsAuthenticated(authRequired);
            })
            .catch(exception => {
                setError(toErrorMessage(exception));
            });
    };

    useEffect(() => {
        replyUserChoice();
    }, []);

    return (
        <div id="user-choice-page" className="user-choice">
            {!error && result && (
                <center>
                    <div className="w-50">
                        <div className="header-container">
                            <h5 className="title text-light">
                                <Translate
                                    message="{playbookname} - User choice"
                                    values={{
                                        playbookname: result.playbook_name
                                    }}
                                />
                            </h5>
                        </div>
                        <Collapse collapseByDefault={false}>
                            <ResultUserChoiceCard
                                data={result}
                                collapsible={false}
                                isAuthenticated={isAuthenticated}
                                key={result.id}
                            />
                        </Collapse>
                    </div>
                </center>
            )}
            {error && (
                <center>
                    <div className="w-50">
                        <h3 className="mb-3">
                            <b className="title">
                                <Translate message="User choice - Error" />
                            </b>
                        </h3>
                        <h4 className="mb-4">
                            <div className="error-content">
                                <div className="text-danger">{error}</div>
                            </div>
                        </h4>
                        <Button
                            className="go-to-login"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                window.location.replace(APP_URL.root);
                            }}
                        >
                            <h4 className="pt-4">
                                <Translate message="Go to login" />
                            </h4>
                        </Button>
                    </div>
                </center>
            )}
        </div>
    );
}
